// src/pages/Annonces/EditAnnonceModal.jsx
import React, { useState, useEffect } from "react";
import { FaSave, FaTimes } from "react-icons/fa";
import Button from "./../../components/Button/Button";
import { updateAnnonce } from "./../../services/annoncesServices";
import { toast } from "react-toastify";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const CATEGORIES = [
  "Recherche Enseignant",
  "Enseignant cherche club",
  "Recherche Matériel",
  "Don Matériel",
  "Autres",
];

const EditAnnonceModal = ({ isOpen, onClose, fetchAnnonces, annonce }) => {
  const [formData, setFormData] = useState({
    category: "",
    title: "",
    content: "",
    image_url: "",
    club_user: "",
    tel_user: "",
    mail_user: "",
    date_annonce: "",
    is_active: true,
    id: "",
  });

  useEffect(() => {
    if (annonce && isOpen) {
      setFormData({
        category: annonce.category || "",
        title: annonce.title || "",
        content: annonce.content || "",
        image_url: annonce.image_url || "",
        club_user: annonce.club_user || "",
        tel_user: annonce.tel_user || "",
        mail_user: annonce.mail_user || "",
        is_active: annonce.is_active,
        date_annonce: annonce.date_annonce
          ? annonce.date_annonce.slice(0, 10)
          : "",
        id: annonce.id,
      });
    }
  }, [annonce, isOpen]);

  const handleChange = (e) => {
    const { name, type, checked, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleContentChange = (value) => {
    setFormData((prev) => ({
      ...prev,
      content: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await updateAnnonce(formData);
      await fetchAnnonces();
      onClose();
      toast.success("Annonce mise à jour avec succès");
    } catch (error) {
      console.error("Erreur lors de la mise à jour de l'annonce", error);
      toast.error("Erreur lors de la mise à jour de l'annonce");
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-slate-900/70 backdrop-blur-sm flex justify-center items-center z-50 px-3">
      <div className="w-full max-w-xl bg-white dark:bg-slate-900 rounded-2xl shadow-2xl border border-slate-200 dark:border-slate-700 p-4 sm:p-6">
        <h3 className="text-lg sm:text-xl font-bold uppercase mb-4 text-center text-white bg-primary rounded-xl py-2 shadow font-montserrat tracking-[0.25em]">
          Modifier l'annonce
        </h3>

        <form onSubmit={handleSubmit} className="space-y-3 text-sm">
          <div>
            <label className="block text-xs font-semibold mb-1">
              Catégorie
            </label>
            <select
              name="category"
              value={formData.category}
              onChange={handleChange}
              className="select select-bordered w-full text-sm dark:bg-slate-800 dark:text-slate-100"
              required
            >
              <option value="" disabled>
                Catégorie de l'annonce
              </option>
              {CATEGORIES.map((c) => (
                <option key={c} value={c}>
                  {c}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label className="block text-xs font-semibold mb-1">Titre</label>
            <input
              type="text"
              name="title"
              placeholder="Titre de l'annonce"
              value={formData.title}
              onChange={handleChange}
              className="input input-bordered w-full text-sm dark:bg-slate-800 dark:text-slate-100"
              required
            />
          </div>

          <div>
            <label className="block text-xs font-semibold mb-1">
              Contenu
            </label>
            <ReactQuill
              value={formData.content}
              onChange={handleContentChange}
              className="mb-1 dark:bg-slate-800 dark:text-slate-100"
            />
          </div>

          <div>
            <label className="block text-xs font-semibold mb-1">
              URL de l'image
            </label>
            <input
              type="url"
              name="image_url"
              placeholder="URL de l'image"
              value={formData.image_url}
              onChange={handleChange}
              className="input input-bordered w-full text-sm dark:bg-slate-800 dark:text-slate-100"
            />
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            <div>
              <label className="block text-xs font-semibold mb-1">Club</label>
              <input
                type="text"
                name="club_user"
                placeholder="Nom du club"
                value={formData.club_user}
                onChange={handleChange}
                className="input input-bordered w-full text-sm dark:bg-slate-800 dark:text-slate-100"
              />
            </div>
            <div>
              <label className="block text-xs font-semibold mb-1">
                Date de l'annonce
              </label>
              <input
                type="date"
                name="date_annonce"
                value={formData.date_annonce || ""}
                onChange={handleChange}
                className="input input-bordered w-full text-sm dark:bg-slate-800 dark:text-slate-100"
              />
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            <div>
              <label className="block text-xs font-semibold mb-1">
                Contact téléphonique
              </label>
              <input
                type="tel"
                name="tel_user"
                placeholder="Téléphone"
                value={formData.tel_user}
                onChange={handleChange}
                className="input input-bordered w-full text-sm dark:bg-slate-800 dark:text-slate-100"
              />
            </div>
            <div>
              <label className="block text-xs font-semibold mb-1">
                Contact email
              </label>
              <input
                type="email"
                name="mail_user"
                placeholder="Adresse email"
                value={formData.mail_user}
                onChange={handleChange}
                className="input input-bordered w-full text-sm dark:bg-slate-800 dark:text-slate-100"
              />
            </div>
          </div>

          <label className="flex items-center gap-2 mt-1 text-xs">
            <input
              type="checkbox"
              name="is_active"
              checked={formData.is_active}
              onChange={handleChange}
              className="checkbox checkbox-primary checkbox-xs"
            />
            <span>Afficher sur la page</span>
          </label>

          <div className="flex justify-center gap-3 pt-3">
            <Button
              text="Mettre à jour"
              icon={FaSave}
              type="submit"
              className="btn-primary gap-2"
            />
            <Button
              text="Annuler"
              icon={FaTimes}
              onClick={onClose}
              type="button"
              className="btn-ghost gap-2"
            />
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditAnnonceModal;
